import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'input-phone-mask',
  template: `
    <input matInput
           [id]="id"
           [type]="to.type || 'text'"
           [formControl]="formControl"
           [formlyAttributes]="field"
           [hiddenInput]="true"
           [patterns]="pattern"
           mask="BBB-BB-0000">
  `
})
export class InputSsnMaskComponent extends FieldType<FieldTypeConfig> {
  pattern = {
    B: {
      pattern: new RegExp('\\d'),
      symbol: 'X',
    },
    0: {
      pattern: new RegExp('\\d'),
    },
  };
}
